module.exports = __webpack_public_path__ + "img/ooca-handon.84336672.png";